// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1RCzT","filesListContainer":"PosDisputesFiles_filesListContainer__2giv4","filesButton":"PosDisputesFiles_filesButton__kdFmy"};